import { UserRoleName } from '@brands/services/identity/types/UserProfile';

export const getPrimaryColor = (): string => {
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color');
  return primaryColor.trim();
};

export const getHoverColor = (): string => {
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--btn_hover_color2');
  return primaryColor.trim();
};

export const getSecondaryColor = (): string => {
  const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary_color');
  return secondaryColor.trim();
};

export const getSecondary = (): string => {
  const secondary = getComputedStyle(document.documentElement).getPropertyValue('--secondary');
  return secondary.trim();
};

export const getBubble_color = (): string => {
  const secondary = getComputedStyle(document.documentElement).getPropertyValue('--bubble_color');
  return secondary.trim();
};

export const getButtonHoverColor = (): string => {
  const secondary = getComputedStyle(document.documentElement).getPropertyValue('--button_hover_color');
  return secondary.trim();
};

export const getPrimaryColorGrad1 = (): string => {
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary_color_grad1');
  return primaryColor.trim();
};

export const getSideNavTextColor = (): string => {
  const secondary = getComputedStyle(document.documentElement).getPropertyValue('--side_nav_text_color');
  return secondary.trim();
};

export const setSideNavColorByRole = (roleName: UserRoleName) => {
  let color = '#003e54';

  switch (roleName) {
    case UserRoleName.Admin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Provider:
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.CareAdvisor:
    case UserRoleName.Collector:
      color = '#0D2035';
      break;

    case UserRoleName.Patient:
      color = '#003e54';
      break;

    default:
      color = '#003e54';
  }

  document.documentElement.style.setProperty('--side-nav-header-color', color);
};
